import React, { Component } from 'react'
import { object, number, node, string, oneOfType, func } from 'prop-types'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap'
import _ from 'lodash'

export class Paginator extends Component {
    static propTypes = {
        pagination: object.isRequired,
        pageRange: number,
        children: node,
        className: string,
        size: string,
        onClick: func.isRequired,
        tag: oneOfType([func, string])
    }
    static defaultProps = {
        pageRange: 7
    }

    renderPrevious = () => {
        const { pagination: { page }, onClick } = this.props
        return (
            <PaginationItem disabled={page === 1}>
                <PaginationLink previous onClick={() => onClick(page - 1)} />
            </PaginationItem>
        )
    }

    renderNext = () => {
        const { pagination: { page, lastPage }, onClick } = this.props
        return (
            <PaginationItem disabled={page === lastPage}>
                <PaginationLink next onClick={() => onClick(page + 1)} />
            </PaginationItem>
        )
    }

    renderPages = () => {
        const { pagination: { page, lastPage }, pageRange, onClick } = this.props
        if (pageRange >= lastPage) {
            return _.times(lastPage, Number).map(i => (
                <PaginationItem key={i} active={page === i + 1}>
                    <PaginationLink onClick={() => onClick(i + 1)}>{i + 1}</PaginationLink>
                </PaginationItem>
            ))
        }
        if (page < Math.round(pageRange / 2)) {
            return _.range(1, pageRange).map(i => (
                <PaginationItem key={i} active={page === i}>
                    <PaginationLink onClick={() => onClick(i)}>{i}</PaginationLink>
                </PaginationItem>
            ))
        }
        if (page > lastPage - Math.round(pageRange / 2)) {
            return _.range(1 + (lastPage - pageRange), lastPage + 1).map(i => (
                <PaginationItem key={i} active={page === i}>
                    <PaginationLink onClick={() => onClick(i)}>{i}</PaginationLink>
                </PaginationItem>
            ))
        }
        const startRange = Math.round(-pageRange / 2)
        const endRange = Math.round(pageRange / 2)
        return _.range(startRange, endRange).map(i => (
            <PaginationItem key={i} active={page === page + i}>
                <PaginationLink onClick={() => onClick(page + i)}>{page + i}</PaginationLink>
            </PaginationItem>
        ))
    }

    renderDots = () => (
        <PaginationItem disabled>
            <PaginationLink>...</PaginationLink>
        </PaginationItem>
    )

    render() {
        const { pagination: { page, lastPage }, pageRange, ...otherProps } = this.props
        if (lastPage === 1) return null
        return (
            <Pagination {...otherProps}>
                {this.renderPrevious()}
                {lastPage > pageRange && page > Math.round(pageRange / 2) && this.renderDots()}
                {this.renderPages()}
                {lastPage > pageRange && !(page > lastPage - Math.round(pageRange / 2)) && this.renderDots()}
                {this.renderNext()}
            </Pagination>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Paginator/Paginator.js